import { Group, Typography, Wrapper } from '@screentone/core';

interface ContentParameter {
  type: string;
  name: string;
  value: {
    start: number;
    end: number | null;
    parameters?: Array<{ type: string; name: string; value: unknown }>;
  };
}

interface ContentParametersValue {
  parameters?: ContentParameter[];
}

interface ContentParametersDisplayProps {
  value: ContentParametersValue;
}

const ContentParametersDisplay = ({ value }: ContentParametersDisplayProps) => {
  if (!value.parameters || !Array.isArray(value.parameters)) {
    return null;
  }

  return (
    <Group direction="row" gap="md" wrap>
      {value.parameters.map((contentParam, cpIdx) => {
        const { start, end: endValue } = contentParam.value;
        const end = endValue ?? 'null';
        const rangeLabel = `${start}-${end}`;

        return (
          <Wrapper key={cpIdx}>
            <Typography variant="label3">[{rangeLabel}] content_parameters:</Typography>
            {contentParam.value.parameters &&
              Array.isArray(contentParam.value.parameters) &&
              contentParam.value.parameters.map((innerParam, ipIdx) => (
                <Typography key={ipIdx} variant="note">
                  <strong>{innerParam.name}</strong>:{' '}
                  {typeof innerParam.value === 'boolean'
                    ? innerParam.value
                      ? 'true'
                      : 'false'
                    : String(innerParam.value)}
                </Typography>
              ))}
          </Wrapper>
        );
      })}
    </Group>
  );
};

export default ContentParametersDisplay;
